import { TranslationPack, useI18n } from '@pega/cosmos-react-core';

const useLocalTranslation = (): ((label: string, ...tokens: (string | number)[]) => string) => {
  const t = useI18n();

  const translate = (label: string, ...tokens: (string | number)[]) => {
    return t(label as keyof TranslationPack, tokens);
  };
  return translate;
};

export default useLocalTranslation;
